module.exports = __webpack_public_path__ + "img/RWApicture.59caabe1.png";